// import React from 'react';
import { 
  Container, 
  Wrapper, 
  Title, 
  Desc, 
  DocGrid, 
  DocCard, 
  DocType, 
  DocTitle, 
  DocDesc, 
  ActionButton,
  IconContainer,
  RespContainer,
  RespWrapper,
  RespItem,
  BubbleIcon,
  RespLabel
} from './PRDStyle';
import { motion } from 'framer-motion';
import { 
  FileText, 
  ExternalLink, 
  BookOpen, 
  BarChart, 
  Search, 
  Layout, 
  Briefcase, 
  Terminal,
  Activity,
  Layers,
  Zap,
  Cpu,
  RefreshCcw,
  Target
} from 'lucide-react';

const documentation = [
  {
    id: 1,
    type: 'PRD',
    title: 'Property Discovery Platform',
    desc: 'B2B real estate search architecting for Muftlo, covering advanced filters, lead management, and capture flows.',
    color: '#854CE6',
    icon: FileText,
    link: 'https://drive.google.com/file/d/17qA1fyFMIswBeHKFOzkalnVRcvv92k7F/view?usp=sharing'
  },
  {
    id: 2,
    type: 'System Design',
    title: 'Flipkart / Amazon',
    desc: 'System Design analysis of large scale Ecommerce platforms, uncovering pricing engines, feature gaps, and scalable positioning strategies.',
    color: '#00D2FF',
    icon: BookOpen,
    link: 'https://drive.google.com/file/d/13l8Rl8F75mSgT0AhOEAW-MSlDGmg0in6/view?usp=sharing'
  },
  {
    id: 3,
    type: 'Case Study',
    title: 'User Onboarding Optimization',
    desc: 'Data-driven study on redesigning the onboarding experience, reducing user drop-off by 35%.',
    color: '#FF4B2B',
    icon: Activity,
    link: 'https://drive.google.com/file/d/1GoMfhjS39jjdmzIQN0JKiPjZxC40MuaC/view?usp=sharing'
  },
  {
    id: 4,
    type: 'System Design',
    title: 'B2B Admin Dashboard Architecture',
    desc: 'Comprehensive system design and technical architecture for scalable multi-tenant real estate dashboards.',
    color: '#FFA000',
    icon: Terminal,
    link: '#'
  },
  {
    id: 5,
    type: 'BRD',
    title: 'Platform Expansion Roadmap',
    desc: 'Business requirements documentation for scaling Muftlo across diverse regional real estate markets.',
    color: '#4CAF50',
    icon: Briefcase,
    link: '#'
  },
  {
    id: 6,
    type: 'SRS',
    title: 'Muftlo API Specifications',
    desc: 'Technical requirements and software specifications for the core RESTful API infrastructure.',
    color: '#E91E63',
    icon: Cpu,
    link: '#'
  }
];

const pmResponsibilities = [
  { icon: Search, label: "Market Research", color: "#854CE6" },
  { icon: Layers, label: "System Design", color: "#00D2FF" },
  { icon: Zap, label: "Product Launches", color: "#FF4B2B" },
  { icon: Target, label: "Agile Leadership", color: "#FFA000" },
  { icon: BarChart, label: "User Analysis", color: "#4CAF50" },
  { icon: RefreshCcw, label: "Lifecycle Mgt", color: "#E91E63" },
  { icon: Layout, label: "UX Prototyping", color: "#00C851" }
];

const PRDLibrary = () => {
  return (
    <Container id="docs">
      <Wrapper>
        <Title>Strategic Documentation</Title>
        <Desc>
          A comprehensive dossier of high fidelity PRDs, Research Papers, System Designs, 
          and Growth Case Studies from my product management journey.
        </Desc>
        
        <DocGrid>
          {documentation.map((doc, index) => (
            <DocCard
              key={doc.id}
              color={doc.color}
              as={motion.div}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              onClick={() => window.open(doc.link, '_blank')}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <IconContainer color={doc.color}>
                   <doc.icon size={24} />
                </IconContainer>
                <DocType color={doc.color}>{doc.type}</DocType>
              </div>
              
              <DocTitle>{doc.title}</DocTitle>
              <DocDesc>{doc.desc}</DocDesc>
              
              <ActionButton color={doc.color} href={doc.link} target="_blank">
                Analyze Document <ExternalLink size={14} />
              </ActionButton>
            </DocCard>
          ))}
        </DocGrid>

        <RespContainer>
          <Title style={{ fontSize: '38px', marginBottom: '20px' }}>Product Ops Engine (0→1→N)</Title>
          <RespWrapper>
            {pmResponsibilities.map((resp, index) => (
              <RespItem 
                key={index}
                as={motion.div}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <BubbleIcon color={resp.color} delay={`${index * 0.2}s`}>
                  <resp.icon size={34} />
                </BubbleIcon>
                <RespLabel>{resp.label}</RespLabel>
              </RespItem>
            ))}
          </RespWrapper>
        </RespContainer>
      </Wrapper>
    </Container>
  );
};

export default PRDLibrary;
